import { doWaitImageByTime } from './../helpers/helpers';
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { emily } from "../characters/Emily";
import { emilyEx } from "../characters/EmilyEx";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V8EmilyAndExAfter } from "./V8";
import Question from '../../src/shell/Questions';
import { endReplay } from '../../src/shell/endReplay';
import { replayScenesList } from '../../src/components/menu/Scenes/replayScenes/scenesReplayData';

export const V8EmilyAndEx = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_0);
    emily.talk(`${emilyEx.name}?! What are you doing here??`);
    emily.talk(`Did you break into my house?!`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_1);
    emilyEx.talk(`What?! No! ${mc.name} let me in...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_3);
    emilyEx.talk(`Here... I brought you a plant just like you like... I know your opinion on flowers...`);

    doWaitImageByTime(images.v8.V8EmilyAndExRoom_2);
    emily.talk(`Don't try to sweet talk me pretending you care about my opinion!`);
    emily.talk(`I've made up my mind... It's over between us.`);

    doWaitImageByTime(images.v8.V8EmilyAndExRoom_4);
    emilyEx.talk(`You never gave me the opportunity to explain...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_6);
    emily.talk(`There is nothing left to explain.`);
    emilyEx.talk(`With everything we've shared together you won't even give me a chance to explain myself?`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_2);
    emily.talk(`Why do you have to make this so difficult?`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_4);
    emilyEx.talk(`Because I love you.`);
    emily.talk(`Bullshit!`);
    emilyEx.talk(`Can we just sit down and talk? Please?`);
    emilyEx.talk(`Just let me get some things off my chest and once I'm done I'll leave.`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_5);
    emily.talk(`Two minutes...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_6);
    emilyEx.talk(`Two minutes...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_7);
    mc.think(`He really has an effect on her...`);

    doWaitImageByTime(images.v8.V8EmilyAndExRoom_8);
    emilyEx.talk(`So...`);
    emilyEx.talk(`It's been really difficult for me not to have you around...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_9);
    emilyEx.talk(`The days have been long, and the nights are even longer...`);
    emilyEx.talk(`The bed always feels cold even on the warmest nights...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_11);
    emilyEx.talk(`Food doesn't taste the same, and things that were fun in the past are now boring...`);

    doWaitImageByTime(images.v8.V8EmilyAndExRoom_9);
    emilyEx.talk(`I know that I crossed a line when I started to get pushy...`);
    emilyEx.talk(`I never should've spied on you...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_10);
    emily.talk(`No! You shouldn't have.`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_11);
    emilyEx.talk(`I understand that now.`);
    emilyEx.talk(`I just couldn't face the thought that I was starting to lose you...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_8);
    emilyEx.talk(`You are everything to me, and I had to be sure that you felt the same...`);
    emilyEx.talk(`I understand now that I brought my worst nightmare to life.`);

    doWaitImageByTime(images.v8.V8EmilyAndExRoom_9);
    emilyEx.talk(`I know that I'm not a catch. But you sure made me feel like one...`);
    emilyEx.talk(`You are so perfect, and I know you can do better than me... And that thought always worried me.`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_11);
    emilyEx.talk(`I know it's the last thing a girl wants to hear... I know it's a huge turn off... But I reached a dead end...`);
    emilyEx.talk(`My actions are just the result of low self-esteem... I'm sorry...`);

    doWaitImageByTime(images.v8.V8EmilyAndExRoom_8);
    emilyEx.talk(`And now I realize that I just want you to be happy... And I feel like I just cause you pain...`);

    doWaitImageByTime(images.v8.V8EmilyAndExRoom_12);
    emilyEx.talk(`And...`);
    emilyEx.talk(`I guess my two minutes are up... Thank you for listening to me...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_11);
    emilyEx.talk(`Bye Emily...`);

    doWaitImageByTime(images.v8.V8EmilyAndExRoom_12);
    emily.talk(`Wait...`);
    emilyEx.talk(`...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_10);
    emily.talk(`I... Miss you too...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_12);
    emilyEx.talk(`You do?`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_10);
    emily.talk(`It's been hard for me as well...`);
    emily.talk(`I've never thought about it like that...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_11);
    emily.talk(`I just couldn't deal with you sneaking up on me and checking my every move!`);
    emily.talk(`I can't be with someone that doesn't trust me.`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_12);
    emilyEx.talk(`If you choose to give me another chance I promise that I'll stop being so jealous...`);


    ImageClass.setImage(images.v8.V8EmilyAndExRoom_14, { wait: true, duration: 1, hideText: true });
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_13);
    emily.talk(`Why do you have to make everything so difficult?`);
    emilyEx.talk(`...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_16);
    emily.talk(`...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_15);
    emily.talk(`Mmm...`);
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_17);
    mc.think(`I can't believe he pulled that off...`);
    mc.think(`Damn. I honestly thought she'd kick him out the minute she saw him.`);

    return jump(V8EmilyAndEx_2, "V8EmilyAndEx_2");
};
export const V8EmilyAndEx_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v8.V8EmilyAndExRoom_18);
    await mc.setQuestion(new Question({ text: `They are really hitting it off... I wonder if I should keep watching or give them some privacy`, options: { think: true }, key: `v8EmilyExKeepWatching` })
        .option({ title: `Keep watching`, key: true })
        .option({ title: `Go to your room`, key: false }));


    if (Question.globalAnswers.v8EmilyExKeepWatching) {

        return jump(V8EmilyAndEx_KeepWatching, "V8EmilyAndEx_KeepWatching");
    }

    return jump(V8EmilyAndEx_End, "V8EmilyAndEx_End");
};
export const V8EmilyAndEx_KeepWatching = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8EmilyExSex_Far);
    mc.think(`Fuck... They didn't wait at all...`);
    ImageClass.setImage(images.v8.Anim_EmilyExSex.poster, { duration: 1, wait: 1, hideText: true });
    ImageClass.setAnimation(images.v8.Anim_EmilyExSex);
    emily.talk(`${emilyEx.name}...`);
    emily.talk(`Ah...`);
    ImageClass.setAnimation(images.v8.Anim_EmilyExSexAngle);
    emilyEx.talk(`It feels so good!`);
    emilyEx.talk(`Babe... I've missed you so much!`);
    ImageClass.setAnimation(images.v8.Anim_EmilyExSexLaying);
    emily.talk(`I missed you too!`);
    emily.talk(`Fuck me...`);
    ImageClass.setAnimation(images.v8.Anim_EmilyExSexLaying, { speed: 3 });
    emily.talk(`Ahh!!`);
    emilyEx.talk(`Babe! I'm about to cum!`);
    ImageClass.setImage(images.v8.Anim_EmilyExHJ.poster, { duration: 1, wait: 1 });
    ImageClass.setAnimation(images.v8.Anim_EmilyExHJ);
    emilyEx.talk(`I missed your touch so much!`);
    ImageClass.setAnimation(images.v8.Anim_EmilyExHJ, { speed: 1.5 });
    emilyEx.talk(`Yes...`);
    emilyEx.talk(`Oh my God... I've missed that.`);
    ImageClass.setImage(images.v8.Anim_EmilyExBJ.poster, { duration: 1, wait: 1 });
    ImageClass.setAnimation(images.v8.Anim_EmilyExBJ);
    emilyEx.talk(`Oh!! I'm so close!`);

    ImageClass.setImage(images.v8.V8EmilyAndExRoom_19);
    emilyEx.talk(`Oh!`);
    ImageClass.setImage(images.v8.V8EmilyAndExRoom_20, { wait: true });
    ImageClass.setImage(images.v8.V8EmilyAndExRoom_19, { wait: true });
    ImageClass.setImage(images.v8.V8EmilyAndExRoom_20, { wait: true });
    ImageClass.setImage(images.v8.V8EmilyAndExRoom_19, { wait: true });
    ImageClass.setImage(images.v8.V8EmilyAndExRoom_20, { wait: true });

    ImageClass.setImage(images.v8.V8EmilyAndExRoom_21, { duration: 1 });
    emily.talk(`Ah...`);

    doWaitImageByTime(images.v8.V8EmilyAndExRoom_18);
    mc.think(`What did he do besides cumming?`);
    mc.think(`She literally did all the work...`);
    mc.think(`I wonder if that's usual for them or just a one-time thing...`);
    mc.think(`I would've expected him to show some affection towards her after all those kind words he said about her.`);

    await endReplay(replayScenesList.v8EmilyEx);
    return jump(V8EmilyAndEx_End, "V8EmilyAndEx_End");
};

export const V8EmilyAndEx_End = async (): Promise<any> => {

    return jump(V8EmilyAndExAfter, "V8EmilyAndExAfter");
};